export default {
  en: {
    Title: "MRMR",
    Tutorial: "Tutorial",
    Period: {
      Title : 'Statement Periods',
      PeriodDate : 'Date',
      Name : 'Name',
      UpdateType: 'Update Type',
      IsActive : 'Active',
      IsYearEnd : "YE",
      IsInternal : "Internal",
      ConfirmDelete : "Do you really want to delete this period {name}?",
      PeriodDeleted: "The selected period was successfully deleted",
      AddNew: "Add Statement Period",
      Edit : "Update Statement Period",
      SelectAll : "Select All",
      Step1 : "Base",
      Step2 : "Projects",
      SubmittedGeoStatementsCount : "Submitted Geo",
      SubmittedEngStatementsCount : "Submitted Eng",
      ApprovedCorpoStatementsCount : "Approved Corpo",
      UnplannedStatementsCount : "Unplanned",
      OpenPeriodStatementsTooltip: "Open period statements",
      LastStartingPointDate: "Last official",
      Project: "Project",
      IsStartingPoint: "New Statement"
    },
    Statement: {
      Title : 'Statements',
      Period : 'Period',
      Project : 'Mineral Deposit',
      Report : 'Report',
      PaginatedReport : 'Paginated Report',
      RawData : 'Export Raw Data',
      Reason : 'Please indicate the reason of the refusal',
      QPEngineering : "QP Engineering",
      QPGeology : "QP Geology",
      Ownership : "Ownership",
      CoreLoggingDatabaseClosureDate : "Fusion Database Closure Date",
      MetallurgicalRecovery: "Metallurgical Recovery (%)",
      Device : "Device",
      FXRate : "FX Rate",
      Notes : "Footnotes",
      ConfirmDelete : "Do you really want to delete this statement?",
      ConfirmDeleteMultiple :  "Do you really want to delete the selected statements?",
      ConfirmSubmission : "Do you really want to submit this statement to corporate?",
      ConfirmCancelSubmission : "Do you really want to cancel this statement submission?",
      NoComment : "No Comment",
      ConfirmNoComments : "Do you really want to submit this statement without any comment?",
      ConfirmApproval : "Do you really want to publish this statement?",
      ConfirmApprovalByEngineering : "Do you really want to approve this statement and submit it to corporate?",
      Reject : "Reject a statement",
      RejectShort : "Reject",
      ApprovalShort : "Approve",
      ConfirmReject : "Do you really want to refuse this statement?",
      StatementDeleted: "The selected statement was successfully deleted",
      MultipleStatementsDeleted : "The selected statements were successfully deleted",
      Duplicate : "Duplicate a statement",
      Renew : "Renew a statement",
      SelectTargetPeriod : "Select the target period",
      DuplicateSuccess : "The statement was successfully duplicated",
      RenewSuccess :  "The statement was successfully renewed",
      NoStatementSelected : "No statement selected",
      ComparaisonStats : "Comparaison stats",
      AuOz : "Gold (Oz)",
      AgOz : "Silver (Oz)",
      ZnOz : "Zinc (Oz)",
      PbOz : "Lead (Oz)",
      CuOz : "Copper (Oz)",
      AuOzShort : "Au (Oz)",
      AuGradeShort : "Au (g/t)",
      New : "Create a new statement",
      Edit : "Edit a statement",
      View : "View a statement",
      Tab1 : "General Information",
      Tab2 : "Statement entries",
      Tab3 : "Comparison analytics",
      UploadTemplateTonnageFile : 'Get the tonnage upload template file',
      UploadTemplateVolumeFile : 'Get the volume upload template file',
      UploadWarning : "Uploading a statement file will override any existing entries",
      UploadFile : "Upload statement file",
      UploadInvalidFileError : "Invalid upload file",
      StatementMustBeCreated : "The statement must be saved before uploading an entry file",
      UploadSuccess : "The entry file has been successfully processed",
      UploadFails : "Upload failure",
      UploadFailText : "The upload file has an unsupported schema.  Please download the latest available template and try again",
      SubmitSuccess : "The selected statement has been successfully submitted",
      CancelSubmissionSuccess : "The selected statement submission has been successfully cancelled",
      RejectSuccess : "The selected statement has been successfully rejected",
      ApprovalSuccess : "The selected statement has been successfully published",
      ApprovalByEngineeringSuccess : "The selected statement has been successfully approved and submitted to corporate",
      NoPreviousComparaison : "No Previous statement available to compare",
      Submission : "Submission",
      Approbation : "Approval",
      EngineeringApproval : "Approval by engineering",
      SubmittedBy : "Submitted by",
      SubmissionDate : "Submission date",
      ApprovalDate : "Approval date",
      ApprovedBy : "Approved by",
      SubmissionNotes : "Submission historic",
      CompareWithTitle: "Compare with",
      PromoteVersionTitle: "Promote a version",
      PromoteVersionTooltip: "Promoting a previous version makes this version as the latest one.  The other versions will remain in the history.",
      ViewVersionTooltip: "Visualize a specific version",
      ViewVersionsTooltip: "Visualize all the versions",
      ConfirmPromoteVersion: "Do you really want to promote this statement version as the latest one?",
      PromoteVersionSuccess : "The version was promoted successfully",
      Version: "Version",
      VersionsTitle: "Versions list",
      Submit: "Submit a statement",
      CancelSubmission: "Cancel statement submission",
      ComparisonUnavailable: "The comparison is not available when there are unsaved changes.",
      SelectElementsChart: "Select elements to display in charts",
      Comparison : "Comparison",
      BackToStatement :  "Back to statement",
      ViewDetailedReport : "View detailed report",
      NotesHelperLine1 : "1. Specific commodity prices if exception by deposit/area/zones (if applicable)",
      NotesHelperLine2 : "2. Inclusive/exclusive of mineral reserves (AEM guidelines is exclusive of mineral reserves)",
      NotesHelperLine3 : "3. MSO yes or no, if yes which software",
      NotesHelperLine4 : "4. Open pit design for Mineral reserves and pit optimization shape for mineral resources",
      NotesHelperLine5 : "5. Cut-off grade or NSR Grade (use 'not less than')",
      NotesHelperLine6 : "6. External Dilution assumptions (range or average), meter equivalent or %",
      NotesHelperLine7 : "7. Mining recovery (range or average)",
      NotesHelperLine8 : "8. Minimum modelling width",
      NotesHelperLine9 : "9. Bulk density (estimated? Fixed by lithology?)",
      NotesHelperLine10 : "10. Estimation method",
      NotesHelperLine11 : "11. Metallurgical recovery assumption/reasoning",
      NotesHelperLine12 : "12. Which Software for estimation and which version",
      NotesHelperLine13 : "13. Any other relevant specification (permitting, zones that has been reclassified, etc)"
    },
    Report : {
      Dashboard : "Dashboard",
      Consolidated :  "Consolidated MRMR Statement",
      PerCommodity : "Consolidated per commodity"
    },
    ElementPrice : {
      Title : "Element prices",
      Name : "Element price",
      Element : "Element",
      Price : "Price",
      ResourceCategory : "Category",
      AddElement: "Add a price",
      EditElement: "Edit price",
      DeleteElement: "Delete price"
    },
    Entry: {
      Title : 'Statement entry',
      AddNew: "Add entry",
      Edit : "Update entry",
      Area : 'Area',
      ResourceType : 'MRMR Category',
      MiningType : 'Mining Method',
      Tonnage : 'Tonnage',
      Volume : 'Volume (m3)',
      Density : 'Density (t/m3)',
      ConfirmRestore : "Do you really want to restore this entry?",
      Restore : "Restore",
      ConfirmDelete : "Do you really want to delete this entry?",
      ConfirmDeleteMultiple :  "Do you really want to delete the selected entries?",
      EntryDeleted: "The selected entry was successfully deleted",
      NoEntrySelected : "No entry selected",
      DuplicatedEntryException : "Already existing entry for this area, mining method and category",
      Grade : "Grade",
      Grams : "g",
      Kilograms : "Kg",
      PreviousGrade : "Previous Grade",
      PreviousTonnage : "Previous tonnage",
      Step1 : "General Information",
      Step2 : "Grades",
      Gold : 'Gold (g/t)',
      Silver : 'Silver (g/t)',
      Copper : 'Copper (%)',
      Zinc : 'Zinc (%)',
      Lead : 'Lead (%)',
      IsInclusive : 'Inclusive?',
      EntryMode : 'Entry mode',
      EntryModeGrade : 'Grade',
      EntryModeQuantity : 'Quantity',
      Elements: "Elements",
      AllElements: "All"
    },
    Devices : {
      '0' : "USD",
      '1' : "CAD",
      '2' : "EUR",
      '3' : "MXN",
      '4' : "AUD"
    },
    ResourceType : {
      '0' : "Mineral Potential",
      '1' : "Inferred",
      '2' : "Indicated",
      '3' : "Measured",
      '4' : "Probable",
      '5' : "Proven"
    },
    ResourceTypeFullName : {
      '0' : "Mineral Potential",
      '1' : "Resources - Inferred",
      '2' : "Resources - Indicated",
      '3' : "Resources - Measured",
      '4' : "Reserves - Probable",
      '5' : "Reserves - Proven"
    },
    MiningType : {
      '0' : "Underground",
      '1' : "Open Pit"
    },
    MetalPrices: {
      '1' : "Mineral reserves",
      '2' : "Mineral ressources"
    },
    ResourceCategories : {
      '1' : "P&P",
      '2' : "M&I",
      '3' : "Inferred",
      '4' : "Mineral Potential"
    },
    NSR : {
      Title : "NSR",
      Scenarios : {
        Title : "NSR Scenarios"
      },
      Analytics : {
        Title : "NSR Analytics"
      }
    },
    QAQC : {
      Title: "QA/QC"
    },
    DiagramType : {
      Summary: "Summary charts",
      Detailed: "Detailed charts",
      DetailedOrSummaryLabel: "Detailed or summary?"
    },
    OwnershipCalculation: {
      Label: "Ownership Calculation?",
      OwnershipPercentage: "Applying AEM Ownership Percentage (%)"
    },
    UpdateType : {
      '0' : "Update",
      '1' : "Update and write off",
      '2' : "Reconduct"
    },
    Qp : {
      Title: "QPs",
      Name: "Name",
      Email: "Email",
      Occupation: "Occupation",
      HireDate: "Hire date",
      AddNew: "Add a QP",
      Edit: "Edit a QP",
      ConfirmDelete: "Do you really want to delete this QP?",
      QpDeleted: "The selected QP was successfully deleted",
      NoQpSelected: "No QP selected",
      Step1: "General Information",
      Step2: "Professional Orders",
      Step3: "Projects",
      ProfessionalOrderRegistrations: "Professional Order Registrations",
      ProfessionalOrderName: "Professional Order",
      RegistrationNumber: "Registration number",
      AllowedProjects: "Allowed projects",
      SelectAll: "Select all",
      DeselectAll: "Deselect all",
      WorkExperience: "Work experience",
      Years: "years",
      Year: "year",
      Months: "months",
      Month: "month",
      Days: "days",
      Day: "day",
      Comments: "Comments"
    },
    QPOccupation : {
      '0' : "Geologist",
      '1' : "Engineer"
    },
    ProfessionalOrder: {
      Title: "Professional Orders",
      Name: "Name",
      AddNew: "Add a professional order",
      Edit: "Edit a professional order",
      ConfirmDelete: "Do you really want to delete this professional order?",
      ProfessionalOrderDeleted: "The selected professional order was successfully deleted",
      NoProfessionalOrderSelected: "No professional order selected"
    },
    Variances: {
      Title: "Variance Reports",
      Upload: {
        Title: "Upload Variance Report",
        UploadFile: "Upload variance report file",
        BrowseFile: "Browse file",
        UploadSuccess: "The variance report has been successfully processed",
        UploadSuccessText: "Please validate and confirm that data fit accordingly with your file and expectations.",
        ValidationRule: "Validation rule",
        ReturnToList: "Return to the list",
        ImportedSuccessfully: "The variance report was successfully imported",
        SubmitNewFile: "Submit a new file",
        ValidationsFailed: "Validations failed",
        ValidationsFailedText: "Please correct the errors and try again",
        BadFileExtension: "Please select an Excel file",
        MRMRVarianceCategoryEnum: {
          0: "Depletion from Mineral Reserves",
          1: "Depletion from Mineral Resources",
          2: "Net change in stockpile balance",
          3: "Interpretation/Drilling",
          4: "Mining Approach",
          5: "New Estimation Parameters",
          6: "New COG",
          7: "Classification Revision (other than drilling)",
          8: "Study and Acquisition"
        },
        ReservesAsEstimated: "Reserves {x} as estimated",
        ResourceAsEstimated: "Resource {x} as estimated"
      },
      VarianceEntries: {
        Name: "Name",
        VarianceGroup: "Variance group",
        Tonnage: "Tonnes",
        Grade: "Grade",
        Ounce: "Ounces",
        Category: "Category",
        ProvenProbable: "Proven & Probable Reserves",
        MeasuredIndicated: "Measured & Indicated Resources",
        Inferred: "Inferred Resources"
      },
      Period: "Period",
      SubmittedBy: "Submitted by",
      SubmissionDate: "Submission date",
      VarianceDeleted: "The selected variance report was successfully deleted",
      ConfirmDelete: "Do you really want to delete this variance report?"
    }
  }
}
